/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Santai_TInputs */

const en_tut_santai_t = /** @type {(inputs: Tut_Santai_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taking a break together`)
};

const id_tut_santai_t = /** @type {(inputs: Tut_Santai_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bersantai bersama`)
};

/**
* | output |
* | --- |
* | "Taking a break together" |
*
* @param {Tut_Santai_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_santai_t = /** @type {((inputs?: Tut_Santai_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Santai_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_santai_t(inputs)
	return en_tut_santai_t(inputs)
});